import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Upload } from 'lucide-react';

export const DocumentsSection = ({ uploadedDocs, handleDocumentUpload, removeDocument }) => (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold font-[Manrope]">Upload Previous Reports/Documents</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>Previous Medical Reports</Label>
            <div className="mt-1">
              <input
                id="previous-report-upload"
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) => handleDocumentUpload(e, 'previous_report')}
                className="hidden"
              />
              <Button
                type="button"
                variant="outline"
                className="w-full"
                onClick={() => document.getElementById('previous-report-upload').click()}
              >
                <Upload className="w-4 h-4 mr-2" />
                Choose Medical Report
              </Button>
            </div>
            <p className="text-xs text-slate-500 mt-1">Max 10MB per file</p>
          </div>
          <div>
            <Label>ID Proof / Patient ID</Label>
            <div className="mt-1">
              <input
                id="id-proof-upload"
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) => handleDocumentUpload(e, 'id_proof')}
                className="hidden"
              />
              <Button
                type="button"
                variant="outline"
                className="w-full"
                onClick={() => document.getElementById('id-proof-upload').click()}
              >
                <Upload className="w-4 h-4 mr-2" />
                Choose ID Proof
              </Button>
            </div>
          </div>
        </div>

        {/* Organized Document Display */}
        <div className="grid grid-cols-2 gap-4">
          {/* Medical Reports */}
          {uploadedDocs.filter(d => d.type === 'previous_report').length > 0 && (
            <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-sm font-medium text-blue-800 mb-2">📋 Medical Reports:</p>
              <div className="space-y-1">
                {uploadedDocs.filter(d => d.type === 'previous_report').map((doc, idx) => (
                  <div key={doc.filename} className="flex items-center justify-between text-xs">
                    <span className="text-blue-800">📄 {doc.filename}</span>
                    <Button
                      type="button"
                      variant="ghost"
                      size="sm"
                      onClick={() => removeDocument(uploadedDocs.indexOf(doc))}
                      className="h-6 text-red-600"
                    >
                      ✕
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* ID Proofs */}
          {uploadedDocs.filter(d => d.type === 'id_proof').length > 0 && (
            <div className="p-3 bg-green-50 rounded-lg border border-green-200">
              <p className="text-sm font-medium text-green-800 mb-2">🆔 ID Proofs:</p>
              <div className="space-y-1">
                {uploadedDocs.filter(d => d.type === 'id_proof').map((doc, idx) => (
                  <div key={doc.filename} className="flex items-center justify-between text-xs">
                    <span className="text-green-800">📄 {doc.filename}</span>
                    <Button
                      type="button"
                      variant="ghost"
                      size="sm"
                      onClick={() => removeDocument(uploadedDocs.indexOf(doc))}
                      className="h-6 text-red-600"
                    >
                      ✕
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="p-3 bg-slate-50 rounded-lg border border-slate-200">
          <p className="text-xs text-slate-600">
            💡 Tip: Upload any previous test reports, prescriptions, or medical records for the doctor's reference
          </p>
        </div>
      </CardContent>
    </Card>

);
